import { useEffect } from 'react'
import { supabase } from '@/lib/supabase/client'
import { useDMStore } from '../store/dm-store'
import { useAuthStore } from '@/features/auth/store/auth-store'

/**
 * Hook leve para carregar apenas o contador de mensagens não lidas de DMs
 * Usado na Dashboard e outras páginas que não precisam carregar todas as conversas
 */
export const useDMUnreadCount = () => {
  const { user } = useAuthStore()
  const { setTotalUnreadCount } = useDMStore()

  useEffect(() => {
    if (!user) return

    /**
     * Carrega contador total de não lidas
     */
    const loadUnreadCount = async () => {
      try {
        const { data, error } = await supabase
          .rpc('get_total_unread_dm_count')

        if (error) throw error

        setTotalUnreadCount(data || 0)
      } catch (error) {
        console.error('Erro ao carregar contador de DMs:', error)
      }
    }

    // Carrega inicial
    loadUnreadCount()

    // Configura real-time para atualizar quando houver novas mensagens
    const channel = supabase
      .channel('dm_unread_count_channel')
      .on(
        'postgres_changes',
        {
          event: 'INSERT',
          schema: 'public',
          table: 'direct_messages',
        },
        () => {
          loadUnreadCount()
        }
      )
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'direct_messages',
        },
        () => {
          loadUnreadCount()
        }
      )
      .subscribe()

    return () => {
      channel.unsubscribe()
    }
  }, [user, setTotalUnreadCount])
}

